/**
 * A utility function to conditionally join class names together.
 * @param {...(string|object|boolean)} classes - The class names to join.
 * @returns {string} - A string of joined class names.
 */
export const cn = (...classes) => {
  return classes
    .filter(Boolean) // Filter out any falsy values (false, null, undefined, etc.)
    .map((className) => {
      if (typeof className === "object") {
        return Object.entries(className)
          .filter(([key, value]) => value) // Only include classes with truthy values
          .map(([key]) => key)
          .join(" ");
      }
      return className; // Return the class name as is
    })
    .join(" "); // Join all class names into a single string
};
